module.exports = __webpack_public_path__ + "img/advanced_analytics.c205182c.png";